import React from 'react';
import LoginButton from './LoginButton';
import {
  Card,
  Typography,
  Button,
  Form,
  Modal
} from 'antd'
import colors from '../../theme/colors'

const { Title, Paragraph } = Typography

const styles = {
  majorDiv: () => ({
    display: 'flex',
    width: '100%',
    height: '100vh',
    justifyContent: 'center'
  }),
  SSOCard: () => ({
    boxShadow: `0px 8px 24px ${colors.LIGHT_SHADOW}`,
    borderRadius: '5px',
    marginTop: 60,
    padding: `30px 0px 30px 0px`,
    display: 'flex',
    flexDirection: 'column',
    width: '35%',
    height: '40%',
    backgroundColor: colors.WHITE,
    justifyContent: 'center',
  }),
  title: () => ({
    textAlign: 'center',
    color: colors.SENSIKA
  }),
  loginDiv: () => ({
    display: 'flex',
    flexDirection: 'column',
    width: '85%',
    alignSelf: 'center'
  })
}

const NotAuthenticated = () => {
  return (
    <>
      <div style={styles.majorDiv()}>
        <div style={styles.SSOCard()}>
          <Title
            level={2}
            style={styles.title()}>
            Welcome to DCD
          </Title>
          <div style={styles.loginDiv()}>
            <Paragraph>This dashboard allows you to sign in with your organization's SSO</Paragraph>
            <LoginButton />
          </div>
        </div>
      </div>
    </>
  )
}

export default NotAuthenticated;

